import { render, staticRenderFns } from "./NoticesTemplates.vue?vue&type=template&id=0f32f91d&"
import script from "./NoticesTemplates.vue?vue&type=script&lang=js&"
export * from "./NoticesTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports